module.exports = __webpack_public_path__ + "static/media/transactionDoneIcon.4c92beea.svg";